import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import ThemeRoutes from 'routes/index';
import { useEffect } from 'react';
import { baseURLFinanceVendor } from 'config/apiConfig';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router';
import Swal from "sweetalert2";

const App = () => {

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchDealersAndVendors = async () => {
      if (
        ["/", "/login", "/success", "/failure"].includes(location.pathname)
      ) {
        Swal.close();
        return;
      }

      const callApi = async (token) => {
        return axios.get(`${baseURLFinanceVendor}getCRMSettings`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      };

      const controller = new AbortController();

      try {
        const token = localStorage.getItem("token");
        const response = await callApi(token);


        if (response?.data?.status) {
          const paymentGateway =
            response?.data?.data?.paymentGateway;

          localStorage.setItem(
            "paymentGateway",
            paymentGateway
          );

        }
      } catch (error) {
        if (error?.response?.status === 401) {
          try {
            const token = localStorage.getItem("token");
            const refreshToken = localStorage.getItem("refreshToken");

            const refreshRes = await axios.post(
              `${baseURLFinanceVendor}Refresh`,
              refreshToken,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              }
            );

            const newToken = refreshRes.data?.token || refreshRes.data;

            localStorage.setItem("token", newToken);

          } catch (refreshError) {

            Swal.fire({
              title: "Session Expired 🔒",
              text: "Please login again.",
              icon: "warning",
              confirmButtonColor: "#6c5dd3",
            });

            localStorage.clear();
            navigate("/login");
          }

          return () => {
            controller.abort();
          }
        }
      }
    };

    fetchDealersAndVendors();
  }, [navigate, location.pathname]);

  return (
    <ThemeCustomization>
      <ScrollTop>
        <ThemeRoutes />
      </ScrollTop>
    </ThemeCustomization>
  )
};

export default App;